import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Button,
  Icon,
} from '@mui/material';
import { useState } from 'react';

interface InformationDialogProps {
  data?: any;
  onClose: (value: boolean) => void;
  open: boolean;
}

const InformationDialog = (props: InformationDialogProps) => {
  const { data, onClose, open } = props;

  const [input, setInput] = useState<string>();

  const handleClose = () => {
    onClose(false);
  };

  const handleConfirm = () => {
    if (data?.onConfirm) {
      data?.onConfirm(input);
    }
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        style: { borderRadius: 30, padding: '20px', minWidth: '300px', backgroundColor: 'var(--surface)' }, // Estilos para el papel del dialog
      }}
    >
      <DialogTitle
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // Asegúrate de que todo esté centrado
          flexDirection: window.innerWidth <= 600 ? 'column' : 'row', // Cambia a columna en móviles
          padding: window.innerWidth <= 600 ? '10px' : '20px', // Padding más coherente
          borderBottom: '1px solid var(--border)', // Línea sutil para separar del contenido
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: window.innerWidth <= 600 ? '10px' : '0', // Margen inferior solo en móviles
          }}
        >
          {data?.title && (
            <span
              style={{
                fontSize: window.innerWidth <= 600 ? '1em' : '1.2em', // Tamaño de fuente adaptable
                fontWeight: 'bold',
                textAlign: 'center', // Asegura que el texto esté centrado
                color: 'var(--text)', // Color del texto segun el tema
              }}
            >
              {' '}
              {data?.icon && <Icon>{data?.icon}</Icon>}
              {data?.title}
            </span>
          )}
        </div>
      </DialogTitle>

      <DialogContent style={{ width: '100%', marginTop: '10px' }}>
        {data?.description && (
          <DialogContentText style={{ marginBottom: '20px', color: 'var(--text-muted)' }}>
            {data?.description}
          </DialogContentText>
        )}
        {data?.setInput && (
          <TextField
            label={data.inputPlaceholder}
            variant='outlined'
            fullWidth
            value={input}
            onChange={(e) => setInput(e.target.value)}
            sx={{
              marginBottom: '10px', // Estilo adicional para TextField
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'var(--border-strong)', // Cambia el color del borde aquí
                },
                '&:hover fieldset': {
                  borderColor: 'var(--border-strong)', // Cambia el color del borde al pasar el mouse
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--border-strong)', // Cambia el color del borde al enfocar
                },
                borderRadius: '15px', // Esto aplica el borderRadius al contenedor del input
                color: 'var(--text)',
                backgroundColor: 'var(--surface)',
              },
            }}
            InputLabelProps={{
              style: { color: 'var(--text-muted)' }, // Etiqueta segun el tema
            }}
          />
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <Button
          onClick={handleClose}
          sx={{
            marginRight: '8px',
            backgroundColor: 'error.main',
            color: 'error.contrastText',
            width: '500px',
            height: '50px',
            borderRadius: '15px',
            fontSize: '1rem',
          }}
        >
          {data?.cancelText || 'Cancel'}
        </Button>
        {data?.onConfirm && (
          <Button
            onClick={handleConfirm}
            sx={{
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              width: '500px',
              height: '50px',
              borderRadius: '15px',
              fontSize: '1rem',
            }}
          >
            Confirm
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default InformationDialog;
